export default __webpack_public_path__ + "static/media/icon-applepay.79146f9afa661f9828ca84caf28b16ca.svg";